module.exports = __webpack_public_path__ + "img/step32_b_printer_power_remove_endcaps - Copy.579c52be.png";